import Api from "./Api";
import axios from "axios";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export default {
  logout() {
    return Api().get(`/logout`);
  },
  registerUser(data) {
    return axios.post(`${data.server.server_api}/api/register`, data.form, {
      headers: headers,
    });
  },
  passportRegisteration(data) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}/api/register`, data, {
      headers: headers,
    });
  },
  checkDuplicated(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/check-unique-field`,
      params,
      {
        headers: headers,
      }
    );
  },
  forgetPassword(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/forgot-password`,
      params,
      {
        headers: headers,
      }
    );
  },
  resetPassword(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/password-reset`,
      params,
      {
        headers: headers,
      }
    );
  },
  verifyPhone(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/verify-token`,
      params,
      {
        headers: headers,
      }
    );
  },
  getUserDetails(id) {
    return axios.get(
      `${process.env.VUE_APP_BASE_URL}/api/user-details/${id}`,
      { headers: headers }
    );
  },
  generatePassportToken(id) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/generate-token-by-id`,
      { id },
      {
        headers: headers,
      }
    );
  },
  oneTimeLoginService(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/login-one-time`,
      params,
      {
        headers: headers,
      }
    );
  },
  verifyOneTimeCodeService(params) {
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/verify-one-time-code`,
      params,
      {
        headers: headers,
      }
    );
  },
  getUserOtpAuthStatus() {
    return Api().get(`/otp-setting`);
  },
  updateUserOtpAuthStatus(payload) {
    return Api().post(`/otp-setting`, payload);
  },
  sendOtpAuthCode(payload) {
    return Api().post(`/otp-resend`, payload);
  },
  verifyOtpAuthCode(payload) {
    return Api().post(`/otp-verify`, payload);
  },
};